// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const Document: React.FC<{ width?: number; height?: number }> = ({ width = 24, height = 24 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0Zm0 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm.573 4.5c.443 0 .86.178 1.172.482l2.76 2.692c.313.305.495.736.495 1.168v7.033c0 .889-.755 1.625-1.667 1.625H8.667C7.755 18.5 7 17.764 7 16.875v-9.75C7 6.236 7.755 5.5 8.667 5.5Zm-.156 1.498v2.361c0 .33.286.61.625.61h2.448l-3.073-2.971Z"
            />
        </svg>
    );
};

export default React.memo(Document);
